import React from "react";
import { useTranslation } from "react-i18next";

const HardwareInclusiveContent = () => {
    const { t } = useTranslation(["translation"]);
    return (
        <div className="fw-b f-16 bos-hwinc-text">{t("ECOPRO_BENEFIT_OF_SUPPLIES_PAGE.HW_INCL")}</div>
    )
}

export default HardwareInclusiveContent;